import { render } from "./FooterContent.vue?vue&type=template&id=74918bf0"
import script from "./FooterContent.vue?vue&type=script&lang=js"
export * from "./FooterContent.vue?vue&type=script&lang=js"

import "./FooterContent.vue?vue&type=style&index=0&id=74918bf0&scope=true&lang=css"
script.render = render

export default script